const DietDurationTypes = {
    NotEligible: 0,
    SixToTwelveHours: 1,
    Above12Hours: 2,
    WithOvernight: 3
};

Object.freeze(DietDurationTypes);

export default DietDurationTypes;